import React from 'react';
import styled from 'styled-components';

export const PageContainer = styled.div<{ isSmallScreen: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: ${({ theme }) => theme.colors.white};

	${({ isSmallScreen }) => !isSmallScreen && 'max-width: 752px; margin: 30px auto 0;'}
`;

export const BodyContainer = styled.div<{ isSmallScreen: boolean }>`
	display: flex;
	flex-direction: column;
	width: 100%;
	margin-top: ${({ isSmallScreen }) => (isSmallScreen ? '25px' : '40px')};
	margin-bottom: ${({ isSmallScreen }) => (isSmallScreen ? '25px' : '40px')};
	padding-left: ${({ isSmallScreen }) => (isSmallScreen ? '15px' : '50px')};
	padding-right: ${({ isSmallScreen }) => (isSmallScreen ? '15px' : '50px')};
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '18px')};
	color: ${({ theme }) => theme.colors.darkR};
`;

export const FieldText = styled.div<{ isSmallScreen: boolean }>`
	color: ${({ theme }) => theme.colors.darkR};
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '18px')};
	margin: ${({ isSmallScreen }) => (isSmallScreen ? '5px 0' : '10px 0')};
`;
